import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';


@Component({
    selector: 'char-limit',
    templateUrl: './char-limit-text.component.html',
    styleUrls: ['./char-limit-text.component.scss'],
})
export class CharLimitTextComponent implements OnInit {
    // Limite máximo de caracteres
    @Input('maxLength') MaxLength: number = 1600;

    // Texto atual
    @Input('value') Value: number = 0;

    // Emite sempre que o valor muda
    // @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();


    constructor() { }

    ngOnInit() { }

}
